module.exports = __webpack_public_path__ + "img/Frame 719.4a162207.png";